import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['formContent', 'iframeWrapper', 'createCta', 'closeButton', 'backButton']

  showIframe () {
    this.formContentTargets.forEach(el => { el.hidden = true })
    this.iframeWrapperTargets.forEach(el => { el.hidden = false })
    this.createCtaTargets.forEach(el => { el.hidden = true })
    this.closeButtonTargets.forEach(el => { el.hidden = true })
    this.backButtonTargets.forEach(el => { el.hidden = false })
  }

  showForm () {
    this.formContentTargets.forEach(el => { el.hidden = false })
    this.iframeWrapperTargets.forEach(el => { el.hidden = true })
    this.createCtaTargets.forEach(el => { el.hidden = this.belongsToInactiveTab(el) })
    this.closeButtonTargets.forEach(el => { el.hidden = false })
    this.backButtonTargets.forEach(el => { el.hidden = true })
  }

  // Some createCta targets are also tab-scoped action buttons (see the
  // "tabs" controller): only one should be visible at a time, matching the
  // currently active tab, otherwise every tab's CTA reappears at once.
  belongsToInactiveTab (el) {
    const activeIndex = this.element.dataset.tabsActiveValue
    if (activeIndex === undefined || el.dataset.index === undefined) return false

    return el.dataset.index !== activeIndex
  }
}
